import { type AltoIcon } from '@alto/design-system';
import React from 'react';
import styled from 'styled-components';

type Props = {
  readonly onClick: () => void;
  readonly AltoIcon: React.ReactElement<typeof AltoIcon>;
};

const Clickable = styled.div`
  cursor: auto;
  &:hover {
    cursor: pointer;
  }
`;

export const ClickableAltoIcon: React.FC<Props> = ({ onClick, AltoIcon }) => {
  return <Clickable onClick={onClick}>{AltoIcon}</Clickable>;
};
